export function infraccionesPage() {
    return {
        infracciones: [],
        search: "",
        isLoading: true,
        openIndex: null,
        dataUrl: "",
        visibleCount: 20,

        init() {
            this.dataUrl = this.$root.dataset.dataUrl || "";
            this.fetchInfracciones();
            // Al buscar, resetear paginación y colapsar detalle abierto
            this.$watch('search', () => {
                this.visibleCount = 20;
                this.openIndex = null;
            });
        },

        normalizeText(text) {
            return text
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");
        },

        async fetchInfracciones() {
            this.isLoading = true;
            try {
                const response = await fetch(this.dataUrl);
                if (!response.ok) {
                    throw new Error(
                        "Error al cargar los datos desde el servidor."
                    );
                }
                this.infracciones = await response.json();
            } catch (error) {
                console.error("Error en fetchInfracciones:", error);
                this.infracciones = [];
            } finally {
                this.isLoading = false;
            }
        },
        get filtered() {
            if (this.search.trim() === "") return this.infracciones;
            const searchNormalized = this.normalizeText(this.search);
            return this.infracciones.filter((infraccion) => {
                const fullText = `${infraccion.infr_codigo} ${infraccion.infr_descripcion} ${infraccion.infr_ampliacion || ""} ${infraccion.infr_asociados || ""}`;
                return this.normalizeText(fullText).includes(searchNormalized);
            });
        },

        get visible() {
            return this.filtered.slice(0, this.visibleCount);
        },

        get hasMore() {
            return this.visibleCount < this.filtered.length;
        },

        loadMore() {
            this.visibleCount += 20;
        },

        toggleDetail(index) {
            this.openIndex = this.openIndex === index ? null : index;
        },
    };
}
